<script setup>
import { useI18n } from 'vue-i18n'
import AppImage from './ui/AppImage.vue'
import RevealOnScroll from './ui/RevealOnScroll.vue'
import { media } from '@/data/content'
import { useSection } from '@/i18n'

const { t } = useI18n()
const s = useSection('proof')
</script>

<template>
  <section :aria-label="t('ui.a11y.implementationProof')" class="px-6 pb-5">
    <RevealOnScroll
      class="mx-auto grid max-w-shell overflow-hidden rounded-[18px] border border-hairline bg-white shadow-[0_40px_90px_-66px_rgba(16,22,28,.6)] md:grid-cols-2"
    >
      <AppImage v-bind="media.proof" :alt="s.imageAlt" class="block h-full w-full bg-night object-contain" />

      <div class="flex flex-col justify-center gap-[14px] px-8 py-11 md:px-10">
        <p class="eyebrow">{{ s.kicker }}</p>
        <h2
          class="m-0 font-display text-[clamp(24px,2.6vw,32px)] font-semibold leading-[1.18] tracking-[-0.02em]"
        >
          {{ s.title }}
        </h2>
        <p class="m-0 text-[15px] leading-[1.65] text-muted">{{ s.body }}</p>
        <ul class="mt-2 flex list-none flex-wrap gap-x-[22px] gap-y-2 p-0 text-[13px] font-semibold text-faint">
          <li v-for="tag in s.tags" :key="tag">{{ tag }}</li>
        </ul>
      </div>
    </RevealOnScroll>
  </section>
</template>
